import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { DOCUMENT, isPlatformBrowser, Location } from "@angular/common";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { combineLatest, Observable, Subscription } from "rxjs";

import { User } from "../../../../shared/models/user";
import { Currency } from "../../../../shared/enums/currency";
import { environment } from "../../../../../environments/environment";
import { ManagerService } from "../../../../core/services/manager.service";
import { DataManagerService } from "../../../../core/services/data-manager.service";
import { GiftName, GiftType } from "../../../../shared/enums";
import { Settings } from "../../../../shared/models";
import { map } from "rxjs/operators";
import { differenceInDays, parseISO } from "date-fns";
import { Router } from "@angular/router";
import { ConfirmUnlockDialogComponent } from "./dialogs/confirm-unlock-dialog/confirm-unlock-dialog.component";
import { InsufficientDialogComponent } from "./dialogs/insufficient-dialog/insufficient-dialog.component";
import { HelpDialogComponent } from "./dialogs/help-dialog/help-dialog.component";
import { ConfigService } from "../../../../core/services/config.service";

@Component({
  selector: "app-bonus-unlock",
  templateUrl: "./bonus-unlock.component.html",
  styleUrls: ["./bonus-unlock.component.scss"],
})
export class BonusUnlockComponent implements OnInit, OnDestroy {
  public Currency = Currency;
  public environment = environment;
  public user: User;
  public gifts = [];
  enumGiftType = GiftType;
  enumGiftName = GiftName;
  public subscripton: Subscription = new Subscription();
  settings: Settings;

  isRAFEnabled$: Observable<boolean>;
  isFDBEnabled$: Observable<boolean>;

  gifts$: Observable<any[]>;
  tickets$: Observable<any[]>;

  rakeback$: Observable<any[]>;
  bonuses$: Observable<any[]>;
  rafBonuses$: Observable<any[]>;

  navigation$: Observable<any[]>;

  tab: string;
  refferralLink: string;
  showPoints$: Observable<boolean>;
  skinsSettings$: Observable<any>;
  constructor(
    private managerService: ManagerService,
    private dataManager: DataManagerService,
    public dialogRef: MatDialogRef<BonusUnlockComponent>,
    private configService: ConfigService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    public ref: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.showPoints$ = combineLatest([
      this.managerService.hideShowPoints$,
      this.managerService.user$,
    ]).pipe(
      map(([hideShowPoints, user]) => {
        const config = hideShowPoints.find(
          (el) => el.Currency === user.selectedCurrency.Id,
        );
        return !config?.Hide;
      }),
    );

    this.isRAFEnabled$ = combineLatest(
      this.managerService.settings$,
      this.managerService.user$,
    ).pipe(
      map(([settings, user]) => {
        if (!settings.RAFEnabled) {
          return false;
        }
        const rafEnabledConfig = JSON.parse(settings.RAFEnabled);
        const config = rafEnabledConfig.find(
          (el) => el.Currency === user.selectedCurrency.Id,
        );
        return config?.Enabled;
      }),
    );

    this.isFDBEnabled$ = combineLatest(
      this.managerService.settings$,
      this.managerService.user$,
    ).pipe(
      map(([settings, user]) => {
        if (!settings.FDBEnabled) {
          return false;
        }

        const fdbEnabledConfig = JSON.parse(settings.FDBEnabled);
        const config = fdbEnabledConfig.find(
          (el) => el.Currency === user.selectedCurrency.Id,
        );
        return config?.Enabled;
      }),
    );

    this.navigation$ = combineLatest(
      this.isRAFEnabled$,
      this.isFDBEnabled$,
      this.managerService.skinsSettings$,
      this.managerService.settings$,
    ).pipe(
      map(([raf, fdb, skinsSettings, settings]) => {
        const navigation = [
          {
            label: "Rakeback",
            value: "rakeback",
          },
          {
            label: "Bonuses",
            value: "bonuses",
          },
          {
            label: "Tickets",
            value: "tickets",
          },
        ];

        if (!raf) {
          const index = navigation.findIndex((el) => el.value === "raf");
          navigation.splice(index, 1);
        }

        if (!fdb) {
          const index = navigation.findIndex((el) => el.value === "bonuses");
          navigation.splice(index, 1);
        }

        // If UseTrueRakeback is true, hide old rakeback tab
        const useTrueRakeback = settings?.UseTrueRakeback?.toLowerCase() === "true";
        
        console.log(
          "skinsSettings",
          skinsSettings,
          !skinsSettings.shouldHaveGiftsRakeBackTab,
          "useTrueRakeback",
          useTrueRakeback,
        );
        
        // Hide old rakeback tab if UseTrueRakeback is true OR if shouldHaveGiftsRakeBackTab is false
        if (useTrueRakeback || !skinsSettings.shouldHaveGiftsRakeBackTab) {
          const index = navigation.findIndex((el) => el.value === "rakeback");
          navigation.splice(index, 1);
        }

        if (!this.tab) {
          this.tab = navigation[0]?.value ?? "";
        }

        return navigation;
      }),
    );

    this.rakeback$ = combineLatest(
      this.managerService.gifts$,
      this.managerService.user$,
    ).pipe(
      map(([data, user]) =>
        data.filter(
          (el) =>
            el.Currency === user.selectedCurrency.Id &&
            el.Type === GiftType.RakeBack,
        ),
      ),
    );

    this.bonuses$ = combineLatest(
      this.managerService.gifts$,
      this.managerService.user$,
    ).pipe(
      map(([data, user]) =>
        data
          .filter(
            (el) =>
              el.Currency === user.selectedCurrency.Id &&
              (el.Type === GiftType.SignupBonus ||
                el.Type === GiftType.DepositBonus),
          )
          .map((el) => {
            // # Parse the ISO string into a Date object
            const date = parseISO(el.Expiration);
            // # Get the current date
            const currentDate = new Date();
            // # Calculate the difference in days
            const daysDifference = differenceInDays(date, currentDate);

            console.log("@d", daysDifference);

            el.days = daysDifference;
            return el;
          }),
      ),
    );

    this.bonuses$.subscribe((bonuses) => console.log(bonuses));

    this.gifts$ = this.managerService.gifts$.pipe(
      map((data) =>
        data.filter((el) => el.Currency > -1 && el.AmountTotal > 0),
      ),
    );

    this.rafBonuses$ = combineLatest(
      this.gifts$,
      this.managerService.rafBonuses$,
    ).pipe(
      map(([gifts, rafBonuses]) => {
        const arr1 = gifts.filter(
          (el) => el.Type === GiftType.ReferAFriendRegister,
        );

        const arr2 = rafBonuses;
        //.filter(el => el.Currency > -1 && el.ReferrerGift?.Currency > -1)

        return [...arr1, ...arr2];
      }),
    );

    this.tickets$ = this.managerService.tickets$;

    // this.subscripton = this.store.select(getUserState).subscribe((user: User) => {
    //   this.user = user;
    //   this.gifts = user.gifts.filter(gift => gift.Currency === user.selectedCurrency);
    // });

    this.managerService.user$.subscribe({
      next: (user) => {
        this.user = user;
        console.log("@user", user.selectedCurrency);
        //this.gifts = user.gifts.filter(gift => gift.Currency === user.selectedCurrency.Id);
      },
    });

    this.managerService.settings$.subscribe({
      next: (settings) => {
        this.settings = settings;
      },
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.subscripton) {
      this.subscripton.unsubscribe();
    }
  }

  get userPoints(): number {
    return (
      this.user?.playerBalance?.[this.user?.selectedCurrency?.Id]?.points ?? 0
    );
  }

  get unlockValue(): number {
    const exchanges = Math.floor(
      this.userPoints / this.settings.PointExchangeRatePoints,
    );
    return exchanges * this.settings.PointExchangeRateValue;
  }

  /** Koliko blokova korisnik može da otključa SADA */
  private blocksAvailableNow(item: any): number {
    // const byPoints = Math.floor(this.userPoints / this.pointsPerBlock);
    // const byBonus = Math.floor(item.AmountRemaining / this.blockValue);
    // return Math.max(0, Math.min(byPoints, byBonus));
    return 0;
  }

  canUnlock(item: any): boolean {
    return this.blocksAvailableNow(item) > 0;
  }

  openHelp(): void {
    this.dialog.open(HelpDialogComponent, {
      width: "350px",
      data: {
        newLayout: this.configService?.config?.newLayout,
        x: this.settings.PointExchangeRatePoints,
        y: this.settings.PointExchangeRateValue,
        currency: this.user?.selectedCurrency,
      },
    });
  }

  onUnlockClick(item: any): void {
    // if (item.PointsRequired / this.settings.PointExchangeRatePoints <=0) {
    //   this.dialog.open(InsufficientDialogComponent, {
    //     width: "350px",
    //     data: {
    //       x: this.settings.PointExchangeRatePoints,
    //       y: this.settings.PointExchangeRateValue,
    //       currency: this.user?.selectedCurrency,
    //  newLayout: this.configService?.config?.newLayout,
    //     },
    //   });
    //   return;
    // }
    const z = item.PointsRequired;
    const w =
      (item.PointsRequired / this.settings.PointExchangeRatePoints) *
      this.settings.PointExchangeRateValue;

    const ref = this.dialog.open(ConfirmUnlockDialogComponent, {
      width: "350px",
      data: {
        z,
        w,
        currency: this.user?.selectedCurrency,
        newLayout: this.configService?.config?.newLayout,
      },
    });

    ref.afterClosed().subscribe((ok) => {
      if (ok) {
        this.unlock(item);
      }
    });
  }

  unlock(gift: any) {
    // if (
    //   !gift.Type &&
    //   gift.Type !== GiftType.RakeBack &&
    //   gift.Type !== GiftType.DepositBonus &&
    //   gift.Type !== GiftType.SignupBonus &&
    //   gift.Type !== GiftType.RakeBack &&
    //   (gift?.Progress < 100 || gift?.ReferrerGift?.Progress < 100)
    // ) {
    //   return;
    // } else if (
    //   gift.Type !== GiftType.RakeBack &&
    //   (gift.Type !== GiftType.DepositBonus ||
    //     gift.Type !== GiftType.SignupBonus) &&
    //   gift?.Progress === 0
    // ) {
    //   return;
    // }
    this.dataManager.unlockGift(
      gift.ReferrerGift ? gift.ReferrerGift.Id : gift.Id,
    );
    // this.managerService.unlockGift(gift, this.settings);
  }

  changeDetection() {
    this.ref.detectChanges();
  }
}
